import { useTranslation } from "react-i18next"
import { login, fetchProfile, fetchGuild, fetchSettings, fetchGuildAchievements, saveProfile, fetchGuilds, fetchUser, fetchGuildItems } from '../api'
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef, useTransition, useContext } from "react";
import { DatePicker, message, Collapse, Input, Form, Radio, Checkbox, Spin, Divider } from 'antd';
import botconfig from '../botconfig';
import { ProfileEmbed } from "../components/ProfileEmbed";
import { format } from 'date-format-parse'
import { runes } from 'runes2';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { LoadingOutlined } from '@ant-design/icons';
import { validatorImage } from "../validators/image";
import { AppHeader } from "../components/AppHeader";
import { Page404 } from "./404";
import { Page401 } from "./401";
import { Page403 } from "./403";
import { LanguageContext } from '../contexts/language'
dayjs.extend(customParseFormat);
export function ProfilePage() {
    const { t } = useTranslation()
    const { guildId, userId } = useParams()
    const [profile, setProfile] = useState()
    const [guild, setGuild] = useState()
    const [settings, setSettings] = useState()
    const [achievements, setAchievements] = useState([])
    const [loading, setLoading] = useState(true)
    const [embed, setEmbed] = useState({ fields: [], gallery: [] })
    const [roles, setRoles] = useState([])
    const [changed, setChanged] = useState({ profile: {}, globalUser: {}, version: 1 })
    const [messageApi, contextHolder] = message.useMessage()
    const [isPending, startTransition] = useTransition()
    const [isSaving, setIsSaving] = useState(false)
    const [valid, setValid] = useState(true)
    const [bioValid, setBioValid] = useState(true)
    const [imageValid, setImageValid] = useState(true)
    const [errorStatus, setErrorStatus] = useState()
    const [items, setItems] = useState([])
    const [ language ] = useContext(LanguageContext)
    function errorMessage(error) {
        if (error) console.error(error)
        messageApi.open({
            type: 'error',
            content: t('Произошла ошибка :('),
        });
    }
    useEffect(() => {
        if (bioValid && imageValid) setValid(true)
        else setValid(false)
    }, [bioValid, imageValid])
    useEffect(() => {
        async function fetchData() {
            let user
            let localItem = JSON.parse(localStorage.getItem("wetbot"))
            if (!localItem?.token) return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            if (localItem.token.expires_at <= Date.now()) {
                localStorage.removeItem("wetbot")
                return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
            } else {
                try {
                    user = await fetchUser(localItem.token)
                } catch (err) {
                    localStorage.removeItem("wetbot")
                    return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
                }
            }
            try {
                let responseGuild
                try {
                    responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                    setGuild(responseGuild)    
                } catch (err) {
                    if (err.response.status === 404) {
                        return setErrorStatus(404)
                    } else if (err.response.status === 401) {
                        await fetchGuilds(user.id, localItem.token.access_token)
                        responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                        setGuild(responseGuild)  
                    } else if (err.response.status === 403) {
                        return setErrorStatus(403)
                    } else {
                        return errorMessage(err)
                    }
                }
                const responseSettings = await fetchSettings(guildId, localItem.token.access_token).then(response => response.response)
                setSettings(responseSettings)
                const responseAchievements = await fetchGuildAchievements(guildId, localItem.token.access_token)
                setAchievements(responseAchievements)
                let responseProfile
                try {
                    responseProfile = await fetchProfile(guildId, userId, localItem.token.access_token).then(response => response.response)
                    document.title = `${responseProfile.displayName} | ${t("Профиль")}`
                    setProfile(responseProfile)
                } catch (err) {
                    if (err.response.status === 404) {
                        return setErrorStatus(404)
                    } else if (err.response.status === 401) {
                        await fetchGuilds(user.id, localItem.token.access_token)
                        responseGuild = await fetchGuild(guildId, localItem.token.access_token).then(response => response.response)
                        setGuild(responseGuild)
                        responseProfile = await fetchProfile(guildId, userId, localItem.token.access_token).then(response => response.response)
                        document.title = `${responseProfile.displayName} | ${t("Профиль")}`
                        setProfile(responseProfile)
                    } else if (err.response.status === 403) {
                        return setErrorStatus(403)
                    } else {
                        return errorMessage(err)
                    }
                }
                const embed = generateEmbed(responseProfile, { profile: {}, globalUser: {} }, responseSettings, responseGuild, responseAchievements)
                setEmbed(embed)
                const responseItems = await fetchGuildItems(guildId, localItem.token.access_token)
                setItems(responseItems)
            } catch (err) {
                errorMessage(err)
            }
            setLoading(false)
        }
        fetchData()
    }, [])
    const useDidMountEffect = (func, deps) => {
        const didMount = useRef(false);
        useEffect(() => {
            if (didMount.current) func();
            else didMount.current = true;
        }, deps);
    }
    useDidMountEffect(() => {
        setEmbed(generateEmbed(profile, changed, settings, guild, achievements))
    }, [changed, language]);   
    function generateEmbed(_profile, changed, settings, guild, achievements) {
        const profile = Object.assign({ ..._profile }, changed.profile, changed.globalUser)
        const tempEmbed = { fields: [], gallery: [] }
        tempEmbed.color = profile.displayHexColor
        let bonusXP
        let bonusCUR
        let bonusLuck
        let bonusRP
        let premium
        let marry
        let cs2rank
        let gender
        const badges = profile.badges.map(badge => botconfig.emojis.badges[badge])
        let boosterEmoji
        if (profile.premiumSinceTimestamp) {
            const premiumTimeStamp = Date.now() - profile.premiumSinceTimestamp
            switch (true) {
                case (premiumTimeStamp >= 63115200000): 
                    boosterEmoji = botconfig.emojis.badges.Booster24Months
                    break
                case (premiumTimeStamp >= 47336400000): 
                    boosterEmoji = botconfig.emojis.badges.Booster18Months
                    break
                case (premiumTimeStamp >= 39447000000): 
                    boosterEmoji = botconfig.emojis.badges.Booster15Months
                    break
                case (premiumTimeStamp >= 31557600000): 
                    boosterEmoji = botconfig.emojis.badges.Booster12Months
                    break
                case (premiumTimeStamp >= 23668200000): 
                    boosterEmoji = botconfig.emojis.badges.Booster9Months
                    break
                case (premiumTimeStamp >= 15778800000): 
                    boosterEmoji = botconfig.emojis.badges.Booster6Months
                    break
                case (premiumTimeStamp >= 7889400000): 
                    boosterEmoji = botconfig.emojis.badges.Booster3Months
                    break
                case (premiumTimeStamp >= 5259600000): 
                    boosterEmoji = botconfig.emojis.badges.Booster2Months
                    break
                default: 
                    boosterEmoji = botconfig.emojis.badges.Booster1Month
                    break
            }
            badges.unshift(boosterEmoji)
        }
        if (profile.donated >= 50) badges.unshift(profile.donated >= 1000 ? botconfig.emojis.badges.DonaterLvl1+botconfig.emojis.badges.DonaterLvl2+botconfig.emojis.badges.DonaterLvl3 : profile.donated >= 500 ? botconfig.emojis.badges.DonaterLvl1+botconfig.emojis.badges.DonaterLvl2 : botconfig.emojis.badges.DonaterLvl1)
        if (profile.admin) badges.unshift(botconfig.emojis.badges.Administrator)
        if (profile.userID === "364726576656678912") badges.unshift(botconfig.emojis.badges.WetbotDeveloper)
        if (guild.ownerId === profile.userID) badges.unshift(botconfig.emojis.badges.ServerOwner)
        let activities = []
        if (profile.presence) {
            for (const activity of profile.presence.activities) {
                const transformedActivity = transformActivity(activity)
                activities.push(transformedActivity)
            }    
        }
        if (getXpBoost(profile)) bonusXP = `${booster(profile.multiplyXP)} ${t("к")} ${botconfig.emojis.XP} ${t("до")} ${format(profile.multiplyXPTime, "DD/MM/YYYY HH:MM")}`
        if (getCurBoost(profile)) bonusCUR = `${booster(profile.multiplyCUR)} ${t("к")} ${settings.emojis.currency} ${t("до")} ${format(profile.multiplyCURTime, "DD/MM/YYYY HH:MM")}`
        if (getLuckBoost(profile)) bonusLuck = `${booster(profile.multiplyLuck)} ${t("к")} ${botconfig.emojis.random} ${t("до")} ${format(profile.multiplyLuckTime, "DD/MM/YYYY HH:MM")}`
        if (getRpBoost(profile)) bonusRP = `${booster(profile.multiplyRP)} ${t("к")} ${botconfig.emojis.RP} ${t("до")} ${format(profile.multiplyRPTime, "DD/MM/YYYY HH:MM")}`
        if (profile.premiumSinceTimestamp) premium = `${boosterEmoji}${t("Бустит сервер с")} ${format(new Date(profile.premiumSinceTimestamp), "DD/MM/YYYY")}`
        if (profile.marry) marry = `${t("В браке с")} <@${profile.marry}> ${profile.marryDate ? `${t("с")} ${format(profile.marryDate, "DD/MM/YYYY")}` : ""}`
        tempEmbed.title = `${profile.displayName}\n${t("Уровень")} 🎖${profile.level}${settings.seasonLevelsEnabled ? `\n${t("Сезонный уровень")} ${profile.seasonLevel}` : ""}`
        if (profile.cs2premiere?.rank !== undefined) cs2rank = `CS2 SR: ${profile.cs2premiere.rank} `
        const status = !profile.presence || profile.presence.status === "offline" ? profile?.lastOnlineHiden || !profile.lastOnline ? `🔴${t("Оффлайн")}` : `${botconfig.emojis[`offline_${profile.device}`]}${t("Был в сети в")} ${format(new Date(profile.lastOnline*1000), 'DD/MM/YYYY HH:MM')}` : `${botconfig.emojis[`${profile.presence.status}_${Object.keys(profile.presence.clientStatus)[0]}`]}${profile.presence.status}`
        if (profile.sex && !profile.hideSex) gender = `${botconfig.emojis[profile.sex]}${t(profile.sex)}`
        const description = [
            status,
            activities.join("\n"),
            badges.join(""),
            bonusXP,
            bonusCUR,
            bonusLuck,
            bonusRP,
            premium,
            marry,
            cs2rank,
            gender,
            `${botconfig.emojis.mic}${(+profile.hours?.toFixed(1) || 0)?.toLocaleString()} ${botconfig.emojis.message}${profile.messages?.toLocaleString() || 0} ${settings.emojis.currency}${Math.floor(profile.currency || 0).toLocaleString()} ${botconfig.emojis.like}${profile.likes?.toLocaleString() || 0} ${botconfig.emojis.cookie}${profile?.cookies?.toLocaleString() || 0} ${botconfig.emojis.upvote}${profile?.upvotes?.toLocaleString() || 0}`
        ]
        tempEmbed.description = description.filter(e => e).join("\n")
        if (profile.bio && !profile.bioHidden) {
            const text = profile.bio.replace(/\\n/g, "\n")
            tempEmbed.fields.push({ name: `${t("Информация")}:`, value: text.slice(0, 1011), inline: false, id: tempEmbed.fields.length })
        }
        if (!profile.socialLinksHidden && (profile.vk || profile.tiktok || profile.instagram || profile.steam)) {
            let socials = ``
            if (profile.vk) socials += `${botconfig.emojis.VK} ${profile.vk}\n`
            if (profile.tiktok) socials += `${botconfig.emojis.TikTok} ${profile.tiktok}\n`
            if (profile.instagram) socials += `${botconfig.emojis.Instagram} ${profile.instagram}\n`
            if (profile.steam) socials += `${botconfig.emojis.Steam} ${profile.steam}\n`
            tempEmbed.fields.push({ name: `${t("Социальные сети")}:`, value: socials, id: tempEmbed.fields.length })
        }
        if (profile.trophies?.length && !profile.trophyHide) {
            tempEmbed.fields.push({ name: `${t("Трофеи")}:`, value: profile.trophies.join("\n"), inline: false, id: tempEmbed.fields.length })
        }
        if (!profile.bannerHidden && (profile.image || profile.bannerURL)) tempEmbed.gallery.push(profile.image || profile.bannerURL)
        if (!profile.thumbnailHidden && (profile.thumbnail || profile.displayAvatarURL)) tempEmbed.thumbnail = profile.thumbnail || profile.displayAvatarURL
        if (!profile.rolesHidden && profile.roles.filter(e => e.name !== "@everyone").length) {
            const rols = profile.roles.filter(e => e.name !== "@everyone").sort((role1, role2) => role2.position - role1.position)
            setRoles(rols)
            tempEmbed.fields.push({
                name: `${t("Роли")}`,
                inline: false,
                id: tempEmbed.fields.length,
                type: "roles"
            })
        }
        let achArr = []
        let achCount = 0
        if (!profile.achievementsHiden) {
            if (achievements.length > 0) {
                let a = achievements.length < 11 ? achievements.length : 11
                for (let i = 0; i < a; i++) {
                    if (profile.achievements?.some(e => e.achievmentID === achievements[i].id)) {
                        let combo = `> ${botconfig.emojis.YES} ` + achievements[i].displayEmoji + achievements[i].name
                        achArr.push(combo)
                    } else {
                        let combo = `> ${botconfig.emojis.NO} ` + achievements[i].displayEmoji + achievements[i].name
                        achArr.push(combo)
                    }
                }
                for (let i = 0; i < achievements.length; i++) {
                    if (profile.achievements?.some(e => e.achievmentID === achievements[i].id)) {
                        achCount++
                    }
                }
                if (achievements.length > 11) achArr.push(`> *... ${t("и ещё")} ${achievements.length - a}*`)
                achArr = achArr.join(`\n`)
            }
            if (achArr.length) tempEmbed.fields.push({ name: `${t("Достижения")} (${achCount}/${achievements.length}):`, value: achArr, inline: false, id: tempEmbed.fields.length })
        }
        let footerText = ""
        if (!profile.joinDateIsHiden) {
            footerText += `${t("Member since")} ${format(profile.joinedAt, 'DD/MM/YYYY')}\n`
        }
        if (!profile.birthdateHidden && profile.birthday_day && profile.birthday_month !== undefined && profile.birthday_year) {
            if (!profile.birthYearHidden) footerText += `${`${t("Дата рождения")}: ${convert(profile.birthday_day)}/${convert(profile.birthday_month)}`}/${profile.birthday_year}・${Math.floor((Date.now() - new Date(profile.birthday_year, (profile.birthday_month - 1), profile.birthday_day))/1000/60/60/24/365.25)} ${t("years old")}`
            else footerText += `${`${t("Дата рождения")}: ${convert(profile.birthday_day)}/${convert(profile.birthday_month)}`}`
        }
        if (footerText.length) {
            tempEmbed.footer = {
                text: footerText,
                icon_url: guild.iconURL
            }
        }
        return tempEmbed
    }
    function transformActivity(activity) {
        return activity.type === 0
        ? `🎮${t("Играет")} ${activity.name}` 
        : activity.type === 1
        ? `🎥${t("Стримит")} ${activity.state}` 
        : activity.type === 2
        ? `🎧${t("Слушает")} ${activity.state} - ${activity.details}`
        : activity.type === 3
        ? `📺${t("Смотрит")} ${activity.state}`
        : activity.type === 5
        ?  `${t("Соревнуется")} ${activity.name}`
        : `${activity.emoji ? activity.emoji : ""}${activity.state || ""}`
    }
    function transformSecs(duration) {
        let ms = parseInt((duration % 1000) / 100),
        secs = Math.floor((duration / 1000) % 60),
        mins = Math.floor((duration / (1000 * 60)) % 60),
        hrs = Math.floor(duration / (1000 * 60 * 60));
        if (hrs) return `${hrs} ${t("ч.")} ${mins} ${t("мин.")} ${secs} ${t("сек.")}`
        if (!hrs) return `${mins} ${t("мин.")} ${secs} ${t("сек.")}`
        if (!mins) return `${secs} ${t("сек.")}`
        if (!secs) return `${ms} ${t("мс.")}`
    }
    function convert(number){
        const converted = number.toString();
        const length = converted.length;
        return length === 1 ? `0${converted}` : converted
    }
    function getXpBoost(profile) {
        return (new Date(profile.multiplyXPTime) < new Date() || !profile.multiplyXPTime) ? 0 : profile.multiplyXP
    }
    function getCurBoost(profile) {
        return (new Date(profile.multiplyCURTime) < new Date() || !profile.multiplyCURTime) ? 0 : profile.multiplyCUR
    }
    function getRpBoost(profile) {
        return (new Date(profile.multiplyRPTime) < new Date() || !profile.multiplyRPTime) ? 0 : profile.multiplyRP
    }
    function getLuckBoost(profile) {
        return (new Date(profile.multiplyLuckTime) < new Date() || !profile.multiplyLuckTime) ? 0 : profile.multiplyLuck
    }
    function booster(number){
        return `${number < 0 ? botconfig.emojis.DOWN : botconfig.emojis.UP}${number * 100}%`
    }
    async function save() {
        setIsSaving(true)
        let localItem = JSON.parse(localStorage.getItem("wetbot"))
        try {
            await saveProfile(profile.userID, profile.guildID, changed, localItem.token.access_token)
        } catch (err) {
            setIsSaving(false)
            if (err) console.error(err)
            return messageApi.open({
                type: 'error',
                content: typeof err.response.data === "array" ? err.response.data.join(", ") : err.response.data,
            });
        }
        setProfile({
            ...profile,
            ...changed.profile,
            ...changed.globalUser
        })
        setChanged({ profile: {}, globalUser: {} })
        setIsSaving(false)
        messageApi.open({
            type: "success",
            content: t("Сохранено"),
        });
    }
    function cancel() {
        setChanged({ profile: {}, globalUser: {}, version: changed.version + 1 })
        messageApi.open({
            type: "info",
            content: t("Сброшено"),
        });
    }
    return (
        !loading ? 
            <>
                {contextHolder}
                <AppHeader></AppHeader>
                <div style={{ display: "flex", justifyContent: "center", paddingTop: 10, alignItems: "center", paddingRight: 20, paddingLeft: 20 }}>
                    <img src={guild.iconURL} alt="" style={{ height: 41, borderRadius: "50%" }}/>
                    <span className="font-800" style={{ fontSize: 30, textAlign: "center" }}>{guild.name}</span>
                </div>
                <div className="container container_page_profile">
                    <div className="profile_container">
                        <div>
                            <ProfileEmbed embed={embed} roles={roles}/>
                        </div>
                    </div>
                    <div className='profile_control_container'>
                        <Collapse accordion items={[
                            {
                                key: "1",
                                label: t("Кастомизация"),
                                children: <div>
                                    <Form
                                        disabled={isSaving}
                                        style={{ gap: 5, display: "grid" }}
                                        layout="vertical"
                                        initialValues={{
                                            bio: profile.bio?.split("<br/>")?.join("\n") || "",
                                            banner: profile.image || "",
                                            birthdate: profile.birthday_day && profile.birthday_month && profile.birthday_year ? dayjs(`${profile.birthday_day}-${convert(profile.birthday_month)}-${profile.birthday_year}`, 'DD-MM-YYYY') : undefined,
                                            vk: profile.vk?.slice(profile.vk.indexOf("https://vk.com/") + 15) || "",
                                            tiktok: profile.tiktok?.slice(profile.tiktok.indexOf("https://tiktok.com/@") + 21) || "",
                                            instagram: profile.instagram?.slice(profile.instagram.indexOf("https://instagram.com/") + 24) || "",
                                            steam: profile.steam?.slice(profile.steam.indexOf("https://steamcommunity.com/") + 30) || "",
                                            gender: profile.sex,
                                            thumbnail: profile.thumbnail
                                        }}
                                        key={`version_${changed.version}`}
                                    >
                                        <Form.Item
                                            style={{ margin: 0 }}
                                            name="bio"
                                            label={t("Описание профиля")}
                                            rules={
                                                [
                                                    {
                                                        required: false, message: t("Пожалуйста, введите описание профиля"), whitespace: true
                                                    }
                                                ]
                                            }
                                        >
                                            <Input.TextArea
                                                rows={4}
                                                count={{
                                                    show: true,
                                                    max: 300,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    const value = input.target.value === "" ? undefined : input.target.value
                                                    if (value !== undefined && value.trim().length === 0) return setBioValid(false)
                                                    setBioValid(true)
                                                    if (value === profile.bio) delete changed.profile.bio
                                                    else {
                                                        if (value === undefined) changed.profile.bio = null
                                                        else changed.profile.bio = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="banner"
                                            label={t("Баннер")}
                                            rules={
                                                [
                                                    {
                                                        required: false, message: t('Пожалуйста, введите ссылку'), whitespace: true
                                                    },
                                                    {
                                                        validator: (rule, value) => {
                                                            const promise = validatorImage(rule, value)
                                                            promise.then(
                                                                result => setImageValid(true),
                                                                error => setImageValid(false)
                                                            )
                                                            return promise
                                                        }
                                                    }
                                                ]
                                            }
                                        >
                                            <Input
                                                placeholder={t("Ссылка")}
                                                count={{
                                                    strategy: (txt) => runes(txt).length
                                                }}
                                                onChange={(input) => {
                                                    let value = input.target.value === "" ? undefined : input.target.value
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.image) delete changed.profile.image
                                                    else {
                                                        if (value === undefined) changed.profile.image = null
                                                        else changed.profile.image = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="thumbnail"
                                            label={t("Миниатюра")}
                                            rules={
                                                [
                                                    {
                                                        required: false, message: t("Пожалуйста, введите ссылку"), whitespace: true
                                                    },
                                                    {
                                                        validator: (rule, value) => {
                                                            const promise = validatorImage(rule, value)
                                                            promise.then(
                                                                result => setImageValid(true),
                                                                error => setImageValid(false)
                                                            )
                                                            return promise
                                                        }
                                                    }
                                                ]
                                            }
                                        >
                                            <Input
                                                placeholder={t("Ссылка")}
                                                count={{
                                                    strategy: (txt) => runes(txt).length
                                                }}
                                                onChange={(input) => {
                                                    let value = input.target.value === "" ? undefined : input.target.value
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.thumbnail) delete changed.profile.thumbnail
                                                    else {
                                                        if (value === undefined) changed.profile.thumbnail = null
                                                        else changed.profile.thumbnail = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="birthdate"
                                            label={t("Дата рождения")}
                                        >
                                            <DatePicker
                                                format="DD-MM-YYYY"
                                                showNow={false}
                                                onChange={(date) => {
                                                    if (profile.birthday_day === date?.$D && profile.birthday_month === (date?.$M+1 || null) && profile.birthday_year === date?.$y) {
                                                        delete changed.profile.birthday_day
                                                        delete changed.profile.birthday_month
                                                        delete changed.profile.birthday_year
                                                    } else {
                                                        changed.profile.birthday_day = date?.$D
                                                        changed.profile.birthday_month = date?.$M+1 || null
                                                        changed.profile.birthday_year = date?.$y    
                                                    }
                                                    setChanged({
                                                        ...changed
                                                    }) 
                                                }}
                                                minDate={dayjs('1900', 'YYYY')}
                                                maxDate={dayjs(`${dayjs().year()}`, 'YYYY')}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="vk"
                                            label={<div style={{ display: "flex", alignItems:" center" }}><img src="https://cdn.discordapp.com/emojis/955846693574836225.png?v=1" alt="" style={{ height:18, width: 18 }}></img><span>VK</span></div>}
                                        >
                                            <Input
                                                addonBefore="https://vk.com/"
                                                count={{
                                                    max: 20,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    const value = input.target.value === "" ? undefined : "https://vk.com/" + input.target.value.trim().replace(/\s/g, '')
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.vk) delete changed.profile.vk
                                                    else {
                                                        if (value === undefined) changed.profile.vk = null
                                                        else changed.profile.vk = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="tiktok"
                                            label={<div style={{ display: "flex", alignItems:" center" }}><img src="https://cdn.discordapp.com/emojis/955847914817744937.png?v=1" alt="" style={{ height:18, width: 18 }}></img><span>TikTok</span></div>}
                                        >
                                            <Input
                                                addonBefore="https://tiktok.com/@"
                                                count={{
                                                    max: 20,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    const value = input.target.value === "" ? undefined : "https://tiktok.com/@" + input.target.value.trim().replace(/\s/g, '')
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.tiktok) delete changed.profile.tiktok
                                                    else {
                                                        if (value === undefined) changed.profile.tiktok = null
                                                        else changed.profile.tiktok = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="instagram"
                                            label={<div style={{ display: "flex", alignItems:" center" }}><img src="https://cdn.discordapp.com/emojis/955848158058016788.png?v=1" alt="" style={{ height:18, width: 18 }}></img><span>Instagram</span></div>}
                                        >
                                            <Input
                                                addonBefore="https://instagram.com/"
                                                count={{
                                                    max: 20,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    const value = input.target.value === "" ? undefined : "https://instagram.com/" + input.target.value.trim().replace(/\s/g, '')
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.instagram) delete changed.profile.instagram
                                                    else {
                                                        if (value === undefined) changed.profile.instagram = null
                                                        else changed.profile.instagram = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="steam"
                                            label={<div style={{ display: "flex", alignItems:" center" }}><img src="https://cdn.discordapp.com/emojis/955848368746274916.png?v=1" alt="" style={{ height:18, width: 18 }}></img><span>Steam</span></div>}
                                        >
                                            <Input
                                                addonBefore="https://steamcommunity.com/id/"
                                                count={{
                                                    max: 20,
                                                    strategy: (txt) => runes(txt).length,
                                                    exceedFormatter: (txt, { max }) => runes(txt).slice(0, max).join('')
                                                }}
                                                onChange={(input) => {
                                                    const value = input.target.value === "" ? undefined : "https://steamcommunity.com/id/" + input.target.value.trim().replace(/\s/g, '')
                                                    if (value !== undefined && value.trim().length === 0) return
                                                    if (value === profile.steam) delete changed.profile.steam
                                                    else {
                                                        if (value === undefined) changed.profile.steam = null
                                                        else changed.profile.steam = value
                                                    }
                                                    startTransition(() => {
                                                        setChanged({
                                                            ...changed
                                                        })
                                                    })
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{ margin: 0, flexGrow: 1 }}
                                            name="gender"
                                            label={t("Гендер")}
                                        >
                                            <Radio.Group buttonStyle="solid" onChange={(event) => {
                                                setChanged({
                                                    ...changed,
                                                    profile: {
                                                        ...changed.profile,
                                                        sex: event.target.value
                                                    }
                                                })
                                            }}>
                                                <Radio.Button value="male">{t("Парень")}</Radio.Button>
                                                <Radio.Button value="female">{t("Девушка")}</Radio.Button>
                                            </Radio.Group>
                                        </Form.Item>
                                    </Form>
                                </div>
                            },
                            {
                                key: "2",
                                label: t("Приватность"),
                                children: <div style={{ display: "grid" }}>
                                    <Checkbox disabled={loading} key={`joinDateIsHiden_${changed.version}`} defaultChecked={profile.joinDateIsHiden} onChange={(event) => {
                                        changed.profile.joinDateIsHiden = event.target.checked || null
                                        if (changed.profile.joinDateIsHiden === profile.joinDateIsHiden) delete changed.profile.joinDateIsHiden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть дату вступления")}</Checkbox>
                                    <Checkbox disabled={loading} key={`achievementsHiden_${changed.version}`} defaultChecked={profile.achievementsHiden} onChange={(event) => {
                                        changed.profile.achievementsHiden = event.target.checked || null
                                        if (changed.profile.achievementsHiden === profile.achievementsHiden) delete changed.profile.achievementsHiden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть достижения")}</Checkbox>
                                    <Checkbox disabled={loading} key={`hideSex_${changed.version}`} defaultChecked={profile.hideSex} onChange={(event) => {
                                        changed.profile.hideSex = event.target.checked || null
                                        if (changed.profile.hideSex === profile.hideSex) delete changed.profile.hideSex
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть гендер")}</Checkbox>
                                    <Checkbox disabled={loading} key={`trophyHide_${changed.version}`} defaultChecked={profile.trophyHide} onChange={(event) => {
                                        changed.profile.trophyHide = event.target.checked || null
                                        if (changed.profile.trophyHide === profile.trophyHide) delete changed.profile.trophyHide
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть трофеи")}</Checkbox>
                                    <Checkbox disabled={loading} key={`isHiden_${changed.version}`} defaultChecked={profile.isHiden} onChange={(event) => {
                                        changed.profile.isHiden = event.target.checked || null
                                        if (changed.profile.isHiden === profile.isHiden) delete changed.profile.isHiden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть профиль")}</Checkbox>
                                    <Checkbox disabled={loading} key={`lastOnlineHiden_${changed.version}`} defaultChecked={profile.lastOnlineHiden} onChange={(event) => {
                                        changed.globalUser.lastOnlineHiden = event.target.checked || null
                                        if (changed.globalUser.lastOnlineHiden === profile.lastOnlineHiden) delete changed.globalUser.lastOnlineHiden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть последний онлайн")}</Checkbox>
                                    <Checkbox disabled={loading} key={`socialLinksHidden_${changed.version}`} defaultChecked={profile.socialLinksHidden} onChange={(event) => {
                                        changed.profile.socialLinksHidden = event.target.checked || null
                                        if (changed.profile.socialLinksHidden === profile.socialLinksHidden) delete changed.profile.socialLinksHidden
                                        setChanged({
                                            ...changed
                                        })
                                    }}>{t("Скрыть социальные сети")}</Checkbox>
                                    <Checkbox disabled={loading} key={`rolesHidden_${changed.version}`} defaultChecked={profile.rolesHidden} onChange={(event) => {
                                        changed.profile.rolesHidden = event.target.checked || null
                                        if (changed.profile.rolesHidden === profile.rolesHidden) delete changed.profile.rolesHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть роли")}</Checkbox>
                                    <Checkbox disabled={loading} key={`bioHidden_${changed.version}`} defaultChecked={profile.bioHidden} onChange={(event) => {
                                        changed.profile.bioHidden = event.target.checked || null
                                        if (changed.profile.bioHidden === profile.bioHidden) delete changed.profile.bioHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть информацию")}</Checkbox>
                                    <Checkbox disabled={loading} key={`bannerHidden_${changed.version}`} defaultChecked={profile.bannerHidden} onChange={(event) => {
                                        changed.profile.bannerHidden = event.target.checked || null
                                        if (changed.profile.bannerHidden === profile.bannerHidden) delete changed.profile.bannerHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть баннер")}</Checkbox>
                                    <Checkbox disabled={loading} key={`thumbnailHidden_${changed.version}`} defaultChecked={profile.thumbnailHidden} onChange={(event) => {
                                        changed.profile.thumbnailHidden = event.target.checked || null
                                        if (changed.profile.thumbnailHidden === profile.thumbnailHidden) delete changed.profile.thumbnailHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть миниатюру")}</Checkbox>
                                    <Checkbox disabled={loading} key={`birthdateHidden_${changed.version}`} defaultChecked={profile.birthdateHidden} onChange={(event) => {
                                        changed.profile.birthdateHidden = event.target.checked || null
                                        if (changed.profile.birthdateHidden === profile.birthdateHidden) delete changed.profile.birthdateHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть дату рождения")}</Checkbox>
                                    <Checkbox disabled={loading} key={`birthYearHidden_${changed.version}`} defaultChecked={profile.birthYearHidden} onChange={(event) => {
                                        changed.profile.birthYearHidden = event.target.checked || null
                                        if (changed.profile.birthYearHidden === profile.birthYearHidden) delete changed.profile.birthYearHidden
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Скрыть год рождения")}</Checkbox>
                                </div>
                            },
                            {
                                key: "3",
                                label: t("Упоминания"),
                                children: <div style={{ display: "grid" }}>
                                    <Checkbox disabled={loading} key={`levelMention_${changed.version}`} defaultChecked={profile.levelMention} onChange={(event) => {
                                        changed.profile.levelMention = event.target.checked || null
                                        if (changed.profile.levelMention === profile.levelMention) delete changed.profile.levelMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о новом уровне")}</Checkbox>
                                    <Checkbox disabled={loading} key={`achievementMention_${changed.version}`} defaultChecked={profile.achievementMention} onChange={(event) => {
                                        changed.profile.achievementMention = event.target.checked || null
                                        if (changed.profile.achievementMention === profile.achievementMention) delete changed.profile.achievementMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о новом достижении")}</Checkbox>
                                    <Checkbox disabled={loading} key={`itemMention_${changed.version}`} defaultChecked={profile.itemMention} onChange={(event) => {
                                        changed.profile.itemMention = event.target.checked || null
                                        if (changed.profile.itemMention === profile.itemMention) delete changed.profile.itemMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о найденном предмете")}</Checkbox>
                                    <Checkbox disabled={loading} key={`roleIncomeMention_${changed.version}`} defaultChecked={profile.roleIncomeMention} onChange={(event) => {
                                        changed.profile.roleIncomeMention = event.target.checked || null
                                        if (changed.profile.roleIncomeMention === profile.roleIncomeMention) delete changed.profile.roleIncomeMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о перезарядке доходной роли")}</Checkbox>
                                    <Checkbox disabled={loading} key={`inviteJoinMention_${changed.version}`} defaultChecked={profile.inviteJoinMention} onChange={(event) => {
                                        changed.profile.inviteJoinMention = event.target.checked || null
                                        if (changed.profile.inviteJoinMention === profile.inviteJoinMention) delete changed.profile.inviteJoinMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о присоединении приглашенного участника")}</Checkbox>
                                    <Checkbox disabled={loading} key={`inviteLeaveMention_${changed.version}`} defaultChecked={profile.inviteLeaveMention} onChange={(event) => {
                                        changed.profile.inviteLeaveMention = event.target.checked || null
                                        if (changed.profile.inviteLeaveMention === profile.inviteLeaveMention) delete changed.profile.inviteLeaveMention
                                        setChanged({
                                            ...changed,
                                        })
                                    }}>{t("Упоминание о выходе приглашенного участника")}</Checkbox>
                                </div>
                            }
                        ]}/>
                    </div>
                </div>
                <div>
                <div className='container profile_inventory'>
                        <Collapse accordion items={[
                            {
                                key: "1",
                                label: t("Инвентарь"),
                                children: <div>
                                    {profile.inventory.filter(inventoryItem => (inventoryItem.amount > 0 || inventoryItem.amount < 0) && items.some(e => e.itemID === inventoryItem.itemID && !e.temp && !e.disabled_due_to_premium && e.visible)).sort((a, b) => {
                                        const aItem = items.find(e => !e.temp && e.itemID === a.itemID)
                                        const bItem = items.find(e => !e.temp && e.itemID === b.itemID)
                                        if (!aItem) return 1
                                        if (!bItem) return -1
                                        return aItem.sort - bItem.sort
                                    }).map((inventoryItem, index, array) => {
                                        const item = items.find(e => e.itemID === inventoryItem.itemID && !e.temp && !e.disabled_due_to_premium && e.visible)
                                        if (item) {
                                            return <><div style={{ display: "flex" }}><div>{item.emojiURL ? <img style={{ width: 20 }} src={item.emojiURL}/> : <span>{item.emoji}</span>}</div><div><span>{item.name} {`(${inventoryItem.amount})`}</span></div></div><div>{item.description}</div>{index+1 < array.length ? <Divider></Divider> : undefined}</>    
                                        }
                                    })}
                                </div>
                            }
                        ]}/>
                    </div>
                </div>
                <div style={{ zIndex: 1000, insetBlockEnd: 20, position: "fixed", right: 20, gap: 10, display: Object.keys(changed.profile).length || Object.keys(changed.globalUser).length ? "flex" : "none" }}>
                    { valid && (Object.keys(changed.profile).length || Object.keys(changed.globalUser).length) ?
                        <>
                            <button
                                disabled={loading}
                                className='button success'  
                                style={{ height: 30, padding: "0 5vw", color: "white" }}
                                onClick={(e) => save()}
                            >{t("Сохранить")}</button>
                        </>
                    : undefined }
                    { Object.keys(changed.profile).length || Object.keys(changed.globalUser).length ?
                        <button
                            disabled={loading}
                            className='button danger'
                            style={{ height: 30, padding: "0 5vw", color: "white" }}
                            onClick={() => cancel()}
                        >{t("Сбросить")}</button>
                    : undefined }
                </div>
            </> 
        :   <>
                {contextHolder}
                {errorStatus === 404 && (<Page404/>) }
                {errorStatus === 401 && (<Page401/>) }
                {errorStatus === 403 && (<Page403/>) }
                {!errorStatus && (<Spin style={{ width: "100%", height: "100%", position: "absolute", display: "flex", justifyContent: "center", alignItems: "center" }} indicator={<LoadingOutlined style={{ fontSize: 300, color: "var(--cookie-color)" }} spin />} />)}
            </>
    )
}